<template>
    <header class="basic-header no-print">
        <nav class="navbar-suite">
            <div :class="[ fullWidth ? 'container-fluid' : 'container' ]">
                <div class="navbar-header">
										<h1 class="header-title">
											<i class="sf sf-comunity-web-portal" aria-hidden="true" :title="title"></i>
											<span :class="{ 'sr-only' : srOnly, 'visible-lg-inline': true }">
												{{ title }}
											</span>
										</h1>
                </div>
                <div v-if="showNav">
                    <ul class="nav navbar-nav navbar-right" role="navigation">
                        <li class="active">
                            <a href="#">Home <span class="sr-only">(current)</span></a>
                        </li>
                        <li><a href="#">Help</a></li>
                        <li class="dropdown">
                            <a 
                                href="#" 
                                class="dropdown-toggle" 
                                data-toggle="dropdown" 
                                role="button" 
                                aria-haspopup="true" 
                                aria-expanded="false"
                            >
                                {{ fullName }} <span class="caret"></span>
                            </a>
                            <ul class="dropdown-menu">
                                <li><a href="#">Account Settings</a></li>
                                <li ><a :href="suiteModule + '-auth/logout'">Log Out</a></li>
                            </ul>
                        </li>
                    </ul>
                </div>
            </div>
        </nav>
    </header>
</template>
<script>
    //import { mapState } from 'vuex'; 
    /**
     * @vue-prop {String} suiteModule - The Sapphire module in view
     * @vue-prop {String} [ title = 'Sapphire Suite' ] - Title in header
     * @vue-prop {Boolean} [ showNav = false ] - Show the header navigation, true/false
     * @vue-prop {Boolean} [ srOnly = false ] - Header title is only visible to screen readers, true/false
     * @vue-prop {Boolean} [ fullWidth = true ] - Header is full width of window, true/false
     * @vue-computed {String} fullName  - The logged-in user's full name
     */
    export default {
        props: {
            suiteModule : {
                type: String,
                required: true
            },
            title : {
                type: String,
                default: "Sapphire Suite"
            },
            showNav : {
                type: Boolean,
                default: false
            },
            srOnly: {
                type: Boolean,
                default: false
            },
            fullWidth: {
                type: Boolean,
                default: true
            }
        },
        computed: {
            // ...mapState( {
            //     fullName: state => {
            //         return state.global.globalData.authUser.firstName + ' ' + state.global.globalData.authUser.lastName;
            //     },
            // })
            fullName(){
                return 'Suzy';
            }
        }
    }
</script>
